var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { ZdsCard, ZdsIcon, ZdsLink } from '@zig-design-system/ui-components-react';
import Alert, { AlertType } from '../../Shared/components/Alert';
import ApiService from '../services/ApiService';
import { RootContext } from '../../Context/RootContext';
import Scroll from '../../Shared/Utility/Scroll';
const Full = () => {
    const [error, setError] = useState(undefined);
    const [startNode, setStartNode] = useState(null);
    const rootContext = useContext(RootContext);
    const apiService = new ApiService(rootContext);
    const startNodeUid = useMemo(() => {
        return rootContext.pluginContext.startNodeUid;
    }, []);
    useEffect(() => {
        const getStartNode = () => __awaiter(void 0, void 0, void 0, function* () {
            const node = yield apiService.getNode(startNodeUid);
            if (!node) {
                setError('Could not fetch node with id ' + startNodeUid);
            }
            else {
                setError(null);
                setStartNode(node);
            }
        });
        getStartNode();
    }, [startNodeUid]);
    if (error) {
        return React.createElement(Alert, { message: error, type: AlertType.error });
    }
    return (React.createElement("div", { className: "zds-row zds-gap-y-3 md:zds-gap-y-6" }, startNode === null || startNode === void 0 ? void 0 : startNode.subnodes.map((subnode, index) => {
        return (React.createElement(React.Fragment, { key: subnode.uid + '-' + index },
            React.createElement("div", { className: "sm:zds-col-6 md:zds-col-4 zds-flex" },
                React.createElement(ZdsCard, { className: "zds-flex-1" },
                    React.createElement("div", { slot: "header" }, subnode.title),
                    React.createElement("div", { slot: "body" },
                        React.createElement(CardBody, { nodeId: subnode.uid }))))));
    })));
};
const CardBody = ({ nodeId }) => {
    const [node, setNode] = useState(null);
    const [error, setError] = useState(undefined);
    const apiService = new ApiService(useContext(RootContext));
    useEffect(() => {
        const getNode = () => __awaiter(void 0, void 0, void 0, function* () {
            const node = yield apiService.getNode(nodeId);
            if (!node) {
                setError('Could not fetch node with id ' + nodeId);
            }
            else {
                setError(null);
                setNode(node);
            }
        });
        getNode();
    }, [nodeId]);
    if (error) {
        return React.createElement(Alert, { message: error, type: AlertType.error });
    }
    return (React.createElement(React.Fragment, null, node === null || node === void 0 ? void 0 : node.subnodes.map((subnode, index) => {
        const link = subnode.externalLink || '#/node/' + subnode.uid;
        const linkTarget = subnode.externalLink ? '_blank' : '_self';
        return (React.createElement("div", { key: subnode.uid + '-' + index, className: "zds-flex-col zds-items-start" },
            React.createElement(ZdsLink, { onZdsClick: () => Scroll.to(0, 0), key: index, link: link, linkTarget: linkTarget, "icon-position": "end", className: "zds-padding-bottom-2" },
                subnode.externalLink && React.createElement(ZdsIcon, { size: "inherit", slot: "icon", name: "open_in_new" }),
                subnode.title)));
    })));
};
export default Full;
